var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ root: !_vm.onHud }},[_c('div',{staticClass:"clock-circle",class:{ onHud: _vm.onHud }},[_c('svg',{attrs:{"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('circle',{attrs:{"cx":"50","cy":"50","r":"45"}}),_c('path',{class:{
            green: _vm.isOverWarningTime,
            orange: _vm.isBetweenWarningAndAlertTime,
            red: _vm.isUnderAlertTime,
            white: _vm.timeIsOver,
          },attrs:{"stroke-dasharray":_vm.circleDashArray,"d":"\n        M 50, 50\n        m -45, 0\n        a 45,45 0 1,0 90,0\n        a 45,45 0 1,0 -90,0\n      "}})])]),_c('span',{staticClass:"clock-timer",class:{
        green: _vm.isOverWarningTime,
        orange: _vm.isBetweenWarningAndAlertTime,
        red: _vm.isUnderAlertTime,
        white: _vm.timeIsOver,
        onHud: _vm.onHud,
      }},[_vm._v(" "+_vm._s(_vm.formattedTimeLeft)+" ")])]),(!_vm.onHud)?_c('div',{staticClass:"tip-group"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }